import { render, staticRenderFns } from "./mlessonword.vue?vue&type=template&id=065ef238&scoped=true&"
import script from "./mlessonword.vue?vue&type=script&lang=js&"
export * from "./mlessonword.vue?vue&type=script&lang=js&"
import style0 from "./mlessonword.vue?vue&type=style&index=0&id=065ef238&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065ef238",
  null
  
)

export default component.exports